// @owners { team: patients-team }
import { type ReduxStateShared } from '~shared/types';

export const getDraftMessage = (state: ReduxStateShared) => state.altoAssistant.draftMessage;
